//const
const EMPLOYEE_LIST_UPDATE_DATA = "employeeList/EMPLOYEE_LIST_UPDATE_DATA";

//reducer
export const employeeList = (state = {
  selectedUser: "",
}, action) => {
  switch (action.type) {
    case EMPLOYEE_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    default:
      return state
  }
};

export const updateData = (data) => {
  return {
    type: EMPLOYEE_LIST_UPDATE_DATA,
    data: data
  }
};
